export const template_en = {
  sequence_template_aside_create_new: "New template",
  sequence_template_main_empty_title: "Nothing here yet",
  sequence_template_main_empty_description:
    "Pick a template from the list to start editing here.",
  version: "Version:",
  sequence_template_version_select_default: "Default",
  sequence_template_version_select_add: "New version",
  sequence_template_set_as_default: "Set as default",
  rename: "Rename",
  delete: "Delete",
  sequence_template_create_dialog_name: "Create New Version",
  sequence_template_edit_dialog_name: "Update Name",
  sequence_template_create_dialog_input_label: "Name",
  sequence_template_edit_dialog_input_label: "Name",
  sequence_template_create_dialog_input_oplaceholder: "Enter a name",
  sequence_template_edit_dialog_input_placeholder: "Enter a name",
  sequence_template_create_dialog_title: "Create New Template",
  sequence_template_create_dialog_template_name_label: "Template name",
  sequence_template_create_dialog_template_name_placeholder: "Enter a name",
  sequence_template_create_dialog_template_channel_label: "Template type",
  sequence_template_create_dialog_template_channel_placeholder:
    "Select template type",
};

export const template_zh_cn = {
  sequence_template_aside_create_new: "新模板",
  sequence_template_main_empty_title: "这里还没有内容",
  sequence_template_main_empty_description: "从列表中选择一个模板来开始编辑。",
  version: "版本：",
  sequence_template_version_select_default: "默认",
  sequence_template_version_select_add: "新增版本",
  sequence_template_set_as_default: "设为默认",
  rename: "重命名",
  delete: "删除",
  sequence_template_create_dialog_name: "创建新版本",
  sequence_template_edit_dialog_name: "更新名称",
  sequence_template_create_dialog_input_label: "名称",
  sequence_template_edit_dialog_input_label: "名称",
  sequence_template_create_dialog_input_oplaceholder: "输入名称",
  sequence_template_edit_dialog_input_placeholder: "输入名称",
  sequence_template_create_dialog_title: "创建新模板",
  sequence_template_create_dialog_template_name_label: "模板名称",
  sequence_template_create_dialog_template_name_placeholder: "输入名称",
  sequence_template_create_dialog_template_channel_label: "模板类型",
  sequence_template_create_dialog_template_channel_placeholder: "选择模板类型",
};

export const template_zh_tw = {
  sequence_template_aside_create_new: "新範本",
  sequence_template_main_empty_title: "這裡還沒有內容",
  sequence_template_main_empty_description: "從列表中選擇一個範本來開始編輯。",
  version: "版本：",
  sequence_template_version_select_default: "預設",
  sequence_template_version_select_add: "新增版本",
  sequence_template_set_as_default: "設為預設",
  rename: "重新命名",
  delete: "刪除",
  sequence_template_create_dialog_name: "建立新版本",
  sequence_template_edit_dialog_name: "更新名稱",
  sequence_template_create_dialog_input_label: "名稱",
  sequence_template_edit_dialog_input_label: "名稱",
  sequence_template_create_dialog_input_oplaceholder: "輸入名稱",
  sequence_template_edit_dialog_input_placeholder: "輸入名稱",
  sequence_template_create_dialog_title: "建立新範本",
  sequence_template_create_dialog_template_name_label: "範本名稱",
  sequence_template_create_dialog_template_name_placeholder: "輸入名稱",
  sequence_template_create_dialog_template_channel_label: "範本類型",
  sequence_template_create_dialog_template_channel_placeholder: "選擇範本類型",
};


export const template_japanese = {
  sequence_template_aside_create_new: "新しいテンプレート",
  sequence_template_main_empty_title: "ここにはまだ何もありません",
  sequence_template_main_empty_description: "編集を開始するにはリストからテンプレートを選択してください",
  version: "バージョン：",
  sequence_template_version_select_default: "デフォルト",
  sequence_template_version_select_add: "バージョンを追加",
  sequence_template_set_as_default: "デフォルトに設定",
  rename: "名前を変更",
  delete: "削除",
  sequence_template_create_dialog_name: "新しいバージョンを作成",
  sequence_template_edit_dialog_name: "名前を更新",
  sequence_template_create_dialog_input_label: "名前",
  sequence_template_edit_dialog_input_label: "名前",
  sequence_template_create_dialog_input_oplaceholder: "名前を入力",
  sequence_template_edit_dialog_input_placeholder: "名前を入力",
  sequence_template_create_dialog_title: "新しいテンプレートを作成",
  sequence_template_create_dialog_template_name_label: "テンプレート名",
  sequence_template_create_dialog_template_name_placeholder: "名前を入力",
  sequence_template_create_dialog_template_channel_label: "テンプレートタイプ",
  sequence_template_create_dialog_template_channel_placeholder: "テンプレートタイプを選択"
};


export const template_korean = {
  sequence_template_aside_create_new: "새 템플릿",
  sequence_template_main_empty_title: "여기에 아직 내용이 없습니다",
  sequence_template_main_empty_description: "편집을 시작하려면 목록에서 템플릿을 선택하세요",
  version: "버전：",
  sequence_template_version_select_default: "기본값",
  sequence_template_version_select_add: "버전 추가",
  sequence_template_set_as_default: "기본값으로 설정",
  rename: "이름 변경",
  delete: "삭제",
  sequence_template_create_dialog_name: "새 버전 만들기",
  sequence_template_edit_dialog_name: "이름 업데이트",
  sequence_template_create_dialog_input_label: "이름",
  sequence_template_edit_dialog_input_label: "이름",
  sequence_template_create_dialog_input_oplaceholder: "이름 입력",
  sequence_template_edit_dialog_input_placeholder: "이름 입력",
  sequence_template_create_dialog_title: "새 템플릿 만들기",
  sequence_template_create_dialog_template_name_label: "템플릿 이름",
  sequence_template_create_dialog_template_name_placeholder: "이름 입력",
  sequence_template_create_dialog_template_channel_label: "템플릿 유형",
  sequence_template_create_dialog_template_channel_placeholder: "템플릿 유형 선택"
};

export const template_hindi = {
  sequence_template_aside_create_new: "नया टेम्प्लेट",
  sequence_template_main_empty_title: "यहां अभी तक कुछ नहीं है",
  sequence_template_main_empty_description: "संपादन शुरू करने के लिए सूची से एक टेम्प्लेट चुनें",
  version: "संस्करण：",
  sequence_template_version_select_default: "डिफ़ॉल्ट",
  sequence_template_version_select_add: "संस्करण जोड़ें",
  sequence_template_set_as_default: "डिफ़ॉल्ट के रूप में सेट करें",
  rename: "नाम बदलें",
  delete: "हटाएं",
  sequence_template_create_dialog_name: "नया संस्करण बनाएं",
  sequence_template_edit_dialog_name: "नाम अपडेट करें",
  sequence_template_create_dialog_input_label: "नाम",
  sequence_template_edit_dialog_input_label: "नाम",
  sequence_template_create_dialog_input_oplaceholder: "नाम दर्ज करें",
  sequence_template_edit_dialog_input_placeholder: "नाम दर्ज करें",
  sequence_template_create_dialog_title: "नया टेम्प्लेट बनाएं",
  sequence_template_create_dialog_template_name_label: "टेम्प्लेट नाम",
  sequence_template_create_dialog_template_name_placeholder: "नाम दर्ज करें",
  sequence_template_create_dialog_template_channel_label: "टेम्प्लेट प्रकार",
  sequence_template_create_dialog_template_channel_placeholder: "टेम्प्लेट प्रकार चुनें"
};